function signin(state = {
  login: [],
  fb: [],
  resetPassword:[],
  fetching: false,
  fetched: false,
  updateProfile:false,
  updateEmail:false,
  updatePassword:false,
  addAddress: false,
  editAddress: false,
  deleteAddress: false,
  defaultAddress:false,
  getAddress:[],
  provinces: false,
  region:false,
  cities:false,
  districts:false,
  error: false,
  errorFB:null,
  errorProvince:false,
  errorCity:false,
  errorDistrict:false,
  errorRegion:false,
  errorResetPassword:false,
  province_fetched:false,
  city_fetched: false,
  reset_password_fetched:false,
  year_fetched:false,
  updateProfileData: null,
  sendOTPError: null,
}, action){
  switch (action.type) {
      case 'SIGNIN_USER_PENDING':{
        return{
          ...state,
          fetching: true,
        }
      }
      case 'SIGNIN_USER_REJECTED':{
        return {
          ...state,
          fetching: false,
          login:[],
          error: action.payload,
        }
      }
      case 'SIGNIN_USER_FULFILLED':{
        return{
          ...state,
          fetching: false,
          fetched: true,
          error:false,
          errorFB:null,
          login: action.payload,
        }
      }

      case 'SIGNEDIN_USER_FULFILLED':{
        return{
          ...state,
          fetching: false,
          fetched: true,
          login: action.payload,
        }
      }

      case 'SIGNEDIN_USER_REJECTED':{
        return{
          ...state,
          fetching: false,
          fetched: false,
          error: action.payload,
        }
      }
    case 'FACEBOOK_SIGNEDIN_USER_FULFILLED':{
      return{
        ...state,
        fetching: false,
        fetched: true,
        fb: action.payload,
      }
    }
    case 'FACEBOOK_SIGNEDIN_USER_REJECTED':{
      return{
        ...state,
        fetching: false,
        errorFB: action.payload,
      }
    }
      case 'UPDATE_CUSTOMER_PASSWORD_FULFILLED':{

        return{
        ...state,
        updatePassword: true,
        }

      }
      case 'UPDATE_CUSTOMER_PASSWORD_REJECTED':{
         return{
            ...state,
            error:action.payload,
         }

      }
       case 'UPDATE_CUSTOMER_EMAIL_FULFILLED':{

        let tempLoginState = state.login;
        tempLoginState.party.email = action.payload.data.attributes.email;

        return{
          ...state,
          updateEmail: true,
          login: tempLoginState,
        }

      }
       case 'UPDATE_CUSTOMER_EMAIL_REJECTED':{

         return{
            ...state,
            error:action.payload,
         }

      }
       case 'UPDATE_CUSTOMER_PROFILE_FULFILLED':{

        let tempLoginState = state.login;

        tempLoginState.party.first_name = action.payload.data.attributes.first_name;
        tempLoginState.party.last_name = action.payload.data.attributes.last_name;
        tempLoginState.party.middle_name = action.payload.data.attributes.middle_name;
        tempLoginState.party.gender = action.payload.data.attributes.gender;
        tempLoginState.party.phone_number = action.payload.data.attributes.phone_number;
        tempLoginState.party.birthdate = action.payload.data.attributes.birthdate;
        tempLoginState.party.email = action.payload.data.attributes.email;

        return{
          ...state,
          updateProfile: true,
          updateProfileData: action.payload,
          login: tempLoginState,
          sendOTP:false,
          sendOTPError: null,
        }

      }
       case 'UPDATE_CUSTOMER_PROFILE_REJECTED':{

         return{
            ...state,
            error:action.payload,
            sendOTPError: action.payload,
         }


      }
      case'LOGOUT_FULFILLED':{
        return{
          ...state,
          fetched:false,
          login:[],
        }

      }
      // RESET ALL INITIAL STATE OF THE VARIABLE INCLUDING ERROR OTHER WAY TO SAY HEY IM RESETTING IT ALL FOR YOU
      case 'RESET_UPDATE_ACCOUNTS':{
        return {
          ...state,
          error:false,
          updateProfile: false,
          updateEmail:false,
          updatePassword:false,
          addAddress: false,
          editAddress: false,
          deleteAddress: false,
          errorResetPassword: false,
          defaultAddress:false,
          errorFB: null,
       }
      }
      case 'CHANGE_PASSWORD_FULFILLED':{
        return {
             ...state,
            login:action.payload,
         }
      }
      case 'CHANGE_PASSWORD_REJECTED':{
        return {
             ...state,
            error:action.payload,
         }
      }
      case 'RESET_PASSWORD_FULFILLED':{
        return {
             ...state,
             reset_password_fetched:true,
             error:false,
            resetPassword:action.payload,
            errorResetPassword: false,
         }
      }
      case 'RESET_PASSWORD_REJECTED':{
        return {
             ...state,
            errorResetPassword:action.payload,
            fetched:false,
         }
      }
      //IF ALL REQUEST WAS REJECTED FOR ADDRESS API CALLS. SINCE ALL REJECTED CASE RETURNS THE SAME PARAMETERS
      case 'ADDRESS_REJECTED':{
        return {
          ...state,
          error: action.payload,
        }
      }
      // LIST OF PROVINCES FROM F3 API
      case 'GET_PROVINCE_FULFILLED':{
        return {
          ...state,
          provinces: action.payload,
          province_fetched: true,
        }
      }
      case 'GET_PROVINCE_REJECTED':{
        return {
          ...state,
          errorProvince: action.payload,
          province_fetched:false,
        }
      }
      // LIST OF CITIES FROM F3 API
      case 'GET_CITY_FULFILLED':{
        return {
          ...state,
          cities: action.payload,
          errorCity:false,
          city_fetched: true,
        }
      }
      case 'GET_CITY_REJECTED':{
        return {
          ...state,
          // cities:false,
          errorCity: action.payload,
          city_fetched:false,
        }
      }
      // LIST OF DISTRICTS FROM F3 API
      case 'GET_DISTRICT_FULFILLED':{
        return {
          ...state,
          districts: action.payload,
          errorDistrict:false,
          district_fetched : true,
        }
      }
      case 'GET_DISTRICT_REJECTED':{
        return {
          ...state,
          // districts:false,
          errorDistrict: action.payload,
          district_fetched:false,
        }
      }
      // GET REGION INFP FROM F3 API
      case 'GET_REGION_FULFILLED':{
        return {
          ...state,
          region: action.payload,
          errorRegion:false,
          region_fetched: true,
        }
      }
      case 'GET_REGION_REJECTED':{
        return {
          ...state,
          // region:false,
          errorRegion: action.payload,
          region_fetched:false,
        }
      }
      // GET INDEX - LIST OF ADDRESS THAT BELONGS TO THIS CUSTOMER
      case 'GET_ADDRESS_FULFILLED':{
        return {
          ...state,
          getAddress: action.payload,
        }
      }
      // ADD NEW ADDRESS AND REFRESH INDEX - LIST OF ADDRESS THAT BELONGS TO THIS CUSTOMER
      case 'ADD_ADDRESS_FULFILLED':{
        let tempLoginState = state.login;

        tempLoginState.party.addresses.push(action.payload);

        return{
          ...state,
          addAddress: true,
          login: tempLoginState,
        }
      }
      // UPDATE EXISTING ADDRESS AND REFRESH INDEX - LIST OF ADDRESS THAT BELONGS TO THIS CUSTOMER
      case 'UPDATE_ADDRESS_FULFILLED':{
        let tempLoginState = state.login;
        let addresses = tempLoginState.party.addresses;

        addresses.forEach((address,index) => {
          if(address.id === action.payload.id){
            addresses[index] = action.payload;
          }
        });

        tempLoginState.party.addresses = addresses;

        return{
          ...state,
          editAddress: true,
          login: tempLoginState,
        }
      }
      // REMOVED EXISTING ADDRESS AND REFRESH INDEX - LIST OF ADDRESS THAT BELONGS TO THIS CUSTOMER
      case 'DELETE_ADDRESS_FULFILLED':{
        let tempLoginState = state.login;
        let addresses = state.login.party.addresses;
        let newAddress = addresses.filter(address => address.id !== action.address_id);

        tempLoginState.party.addresses = newAddress;

        return{
          ...state,
          deleteAddress: true,
          login: tempLoginState,
        }
      }

      case 'DEFAULT_ADDRESS_FULFILLED': {
          let tempLoginState = state.login;

          tempLoginState.party.address_id = action.payload.data.attributes.address_id;

          return {
              ...state,
              defaultAddress: true,
              login: tempLoginState
          }
      }
      case 'GET_YEAR_FULFILLED':{
      return{
        ...state,
        year_fetched:true,
        year: action.payload,
      }
    }
      case 'GET_YEAR_REJECTED':{
        return {
          ...state,
          year_fetched:false,
          error: action.payload,
        }
    }
    case 'SEND_OTP_FULFILLED':{
    return{
      ...state,
      sendOTP:true,
      sendOTPSuccess: action.payload,
      sendOTPError: null,
      error: null,
      updateProfileData: null,
    }
  }
  case 'SEND_OTP_REJECTED':{
    return {
      ...state,
      sendOTP:false,
      sendOTPError: action.payload,
      error: action.payload
    }
  }
  case 'UPDATE_CUSTOMER_TUTORIAL_FULFILLED':{
    let tempLoginState = state.login;
    tempLoginState.party.party.metadata = action.payload.party.party.metadata;
    return{
      ...state,
      login: tempLoginState,
    }
  }
    default:break
   }
   return state;
}

export default signin;



/** WEBPACK FOOTER **
 ** ./src/reducers/signin.js
 **/